module.exports = "data:image/gif;base64,R0lGODlhIAAgAMQAAIaGhgCZ/xVrmwhqnxZkmh1cjQxflghfkxJPgw5PgxdMfwpPhQZPgwJPgyJDbzM8YjUkAD0YDCQMABQQAD0AADEAAC0AACQAABwAABQABAwAAAQAAP///wAAAAAAAAAAACH5BAEAABwALAAAAAAgACAAAAWdICeOZGmeaLmtW+qi7Ri/NGCLNkC/eZ/vKJ9QByQNh0XcUTijbZYYzNO2+qVawwcLkqtUXzHmSuJjgZU51mRovnJ8llVk2Yb5NJv5ElA/lS97aSsugYWEhXuHiEcuLItVVjAbFg6BGxcUPU0lfBuZdJdCKVSQQhmlPaMijmWoqU6hglOiQKWstEWzrpFJhklGS78mjMLDPsV2N8jIIQA7"


//////////////////
// WEBPACK FOOTER
// ./static/images/MapIcon/Car/CHeadNW_S7.gif
// module id = zzOK
// module chunks = 48